import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  TablePagination,
  Typography,
  CircularProgress,
  ListItem,
  List,
  Button,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import { invitationKey, url } from ".";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function LogsDetails(props) {
  const [rows, setRows] = useState(props.rows ? props.rows : []);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [load, setLoad] = useState(false);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  const [days, setDays] = useState(null);

  const getHistory = async (key) => {
    try {
      const response = await axios.get(`${url}/history/${key}`);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const getLogsDetails = async (name, day) => {
    try {
      const response = await axios.get(
        `${url}/invitepersonlog/${name}?Date=${day} Day`
      );
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(async () => {
    if (days && props.rows?.length > 0) {
      const newCmp = await getLogsDetails(props.rows[0].Invitation, days);
      setRows(newCmp);
    } else {
      setRows(props.rows);
    }
  }, [days]);

  useEffect(async () => {
    if (props.rows) {
    } else {
      setLoad(true);
      const pastHistory_ = await getHistory(invitationKey);
      setRows(pastHistory_);
      setLoad(false);
    }
  }, []);

  return (
    <TableContainer
      component={Paper}
      style={{
        width: isDesktopOrLaptop && props.rows === undefined ? "25vw" : "60vw",
        height: props.rows ? "100%" : "50vh",
      }}
    >
      {rows?.length > 0 ? (
        props.rows?.length ? (
          <>
            <Table size="small" style={{ tableLayout: "fixed" }} stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell align="right">Invitation</TableCell>
                  <TableCell align="right">Query</TableCell>
                  <TableCell align="right">Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow key={row.Time}>
                      <TableCell>{row.Date}</TableCell>
                      <TableCell align="right">{row.Invitation}</TableCell>
                      <TableCell align="right">{row.Query}</TableCell>
                      <TableCell align="right">{row.Time}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
            <TableRow style={{ display: "flex", alignItems: "center" }}>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={3}
                count={rows?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={(event, page_) => {
                  setPage(page_);
                }}
                onChangeRowsPerPage={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
              />
              <Button
                variant={"contained"}
                color="primary"
                size="small"
                style={{ marginLeft: "5px", fontSize: "10px" }}
                onClick={(event) => {
                  setDays(1);
                }}
              >
                1 Day
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginLeft: "5px", fontSize: "10px" }}
                onClick={(event) => {
                  setDays(7);
                }}
              >
                7 Days
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginLeft: "5px", fontSize: "10px" }}
                onClick={(event) => {
                  setDays(30);
                }}
              >
                30 Days
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ marginLeft: "5px", fontSize: "10px" }}
                onClick={(event) => {
                  setDays(10000);
                }}
              >
                All
              </Button>
            </TableRow>
          </>
        ) : (
          <div>
            <List>
              <Typography style={{ paddingLeft: "16px" }}>History</Typography>

              {rows.map((query) => {
                return (
                  <ListItem
                    divider
                    component={Link}
                    style={{
                      fontWeight: 300,
                      fontSize: "16px",
                      color: "#6C6A6A",
                      textDecoration: "",
                      fontFamily: "Source Sans Pro",
                    }}
                    to="./search-results"
                    onClick={() => {
                      props.setSearchKeyword(query.Query);
                      props.setSearchedState({
                        ...props.searchedState,
                        companies: [],
                        filters: {},
                        Sectors: [],
                        directAnswers: [],
                        directAnswer2: "",
                        name: query.Query,
                        ISIN: null,
                      });
                      props.setAnchorEl(null);
                    }}
                  >
                    <Typography>{query.Query}</Typography>
                  </ListItem>
                );
              })}
            </List>
          </div>
        )
      ) : (
        <div
          style={{
            minHeight: "50vh",
            minWidth: isDesktopOrLaptop ? "30vw" : "50vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {load ? (
            <CircularProgress />
          ) : (
            <Typography>No Results Available from the last 2 days</Typography>
          )}
        </div>
      )}
    </TableContainer>
  );
}
